import { render, staticRenderFns } from "./MainPageFAQCard.vue?vue&type=template&id=f7057ef6&scoped=true&"
import script from "./MainPageFAQCard.vue?vue&type=script&lang=js&"
export * from "./MainPageFAQCard.vue?vue&type=script&lang=js&"
import style0 from "./MainPageFAQCard.vue?vue&type=style&index=0&id=f7057ef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7057ef6",
  null
  
)

export default component.exports